// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zKs9X","colBig":"styles_colBig__3U91A","colSmall":"styles_colSmall__pTNiS"};